import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { BusinessProfileResponse } from 'apis/business/types';
import { getBusiness } from 'apis/agency/api';
import { CacheKeys } from 'utils/cacheKeys';
import { useBusiness } from 'providers/context/BusinessProvider';
import { useAgent } from '@/providers/context/AgentProvider';

type OpenBusinessOptions = { openInNewTab?: boolean };

export function useOpenBusinessWorkspace() {
  const navigate = useNavigate();
  const { setSelectedBusiness, setSelectedLocation } = useBusiness();
  const { setSelectedAgentId } = useAgent();

  const openBusinessWorkspace = useCallback(
    (business: BusinessProfileResponse, options?: OpenBusinessOptions) => {
      if (!business) return;

      const locationIds = business?.locations?.map((item) => item.id);

      if (options?.openInNewTab) {
        localStorage.setItem(CacheKeys.businessIds, JSON.stringify([business.id]));
        localStorage.setItem(CacheKeys.locationIds, JSON.stringify(locationIds));
        window.open('/', '_blank', 'noopener,noreferrer');
        return;
      }

      localStorage.clear();
      setSelectedAgentId(undefined);
      setSelectedBusiness(Number(business.id));
      setSelectedLocation(Number(business?.locations?.[0]?.id));
      localStorage.setItem(CacheKeys.businessIds, JSON.stringify([business.id]));
      localStorage.setItem(CacheKeys.locationIds, JSON.stringify(locationIds));
      navigate('/');
    },
    [navigate, setSelectedAgentId, setSelectedBusiness, setSelectedLocation]
  );

  const openBusinessWorkspaceById = useCallback(
    async (businessId: number, options?: OpenBusinessOptions) => {
      try {
        const business = await getBusiness(businessId, {
          include: ['business_plan', 'locations', 'telephony_providers']
        });
        openBusinessWorkspace(business, options);
      } catch (err) {
        console.error(err);
      }
    },
    [openBusinessWorkspace]
  );

  return { openBusinessWorkspace, openBusinessWorkspaceById };
}
